const FATAL_ERROR_PATTERN = /incorrect api key|invalid api key|unauthorized/i;

/**
 * Erros de chave de API sao permanentes: a Soniox chama `onStarted` assim que o
 * WebSocket abre, antes de validar a chave no servidor, entao esse erro chega
 * como um `onError` normal em plena "gravacao". Reconectar automaticamente so
 * repetiria o mesmo erro para sempre — precisa ser tratado como terminal.
 */
export const isFatalSonioxError = (status: string, message: string): boolean =>
  status === "api_key_fetch_failed" || FATAL_ERROR_PATTERN.test(message);
